import { App } from 'vue'
import ChoiceChips from '@/components/choice-chips/LpChoiceChip.vue'

ChoiceChips.install = (Vue: App) => {
  Vue.component(ChoiceChips.name, ChoiceChips)
}

export default ChoiceChips
